"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTcoResult = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.calculateTcoResult = (0, graphql_tag_1.default) `
  mutation SaveAndCalculateTcoResultMutation($input: CalculateTcoInputType!) {
    saveAndCalculateTco(input: $input) {
      logTraceId
      success
      tcoCalcErrors {
        errors
        systemErrors {
          systemId
          error
        }
      }
      result {
        systemResults {
          id
          result
          tcoSystemId
        }
        compareResults {
          id
          result
          tcoSystemId
          baseTcoSystemId
        }
      }
    }
  }
`;
//# sourceMappingURL=calculate-tco-result.js.map